import {
	AUTH,
	DETAILED_RECIPE,
	REQUESTING
} from '../constants';
import {requestError} from './error';
import Errors from '../errors';
import firebaseAdaptor from '../firebaseAdaptor';

// Initialize Cloud Firestore through Firebase
var db = firebaseAdaptor.db;

function setObserver(observer){
	return {
		type : AUTH.SET_AUTH_OBSERVER,
		payload:{
			observerId : 'requestScore',
			observer
		}
	};
}

export function getScore(uid,onSuccess,onFail){
	db.collection('scores')
		.where('uid', '==', uid)
		.get()
		.then(function(querySnapshot){
			let scores = [];
			querySnapshot.forEach(function(doc) {
				let score = Object.assign(doc.data());
				scores.push(score);
			});
			onSuccess(scores);
		})
		.catch(onFail);
}

export function requestSaveScore (score, nextAction = null){
	return (dispatch, getState)=>{
		const {auth} = getState();
		if(auth&&score){
			db.collection('scores').add({
				uid: auth.uid,
				userName: auth.userName,
				...score,
			})
				.then(nextAction&&nextAction)
				.catch(function(error) {
					dispatch(requestError(DETAILED_RECIPE.CREATE_SCORE, error, ));
				});
		}
	};
}

export const requestScore = (dispatch, getState)=>{
	const {location} = getState();
	const {recipeId} = location.payload;
	const {auth} = getState();
	const exec = (uid)=>{
		db.collection('scores')
			.where('uid', '==', uid)
			.where('recipeId', '==', recipeId)
			.get()
			.then(function(querySnapshot){
				let scores = [];
				querySnapshot.forEach(function(doc) {
				// doc.data() is never undefined for query doc snapshots
					let score = Object.assign(doc.data());
					scores.push(score);
				});
				dispatch({
					type:DETAILED_RECIPE.READ_SCORE,
					payload:{
						fetchingState : REQUESTING.LOADED,
						scores
					}
				});
			})
			.catch(error=>{
				dispatch(requestError(DETAILED_RECIPE.READ_SCORE,error,Errors.NotFoundScore,Errors.AddScoreFailed));
			});
	};
	if(auth.uid){
		exec(auth.uid);
	}
	else{
		dispatch(setObserver(
			(user)=>{
				exec(user.uid);
				dispatch(setObserver(null));
			}
		));
	}
	
};